import { render, staticRenderFns } from "./CUserAvatar.vue?vue&type=template&id=297b0ad7&scoped=true"
import script from "./CUserAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CUserAvatar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CUserAvatar.vue?vue&type=style&index=0&id=297b0ad7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297b0ad7",
  null
  
)

export default component.exports